import { optionMatchesSearch } from "@/components/ui/option-matches-search";

import type { FilterOption } from "./filter-select";

export function filterOptionsBySearch(
  options: FilterOption[],
  searchable: boolean | undefined,
  search: string,
): FilterOption[] {
  if (!searchable) return options;
  if (!search) return options;
  return options.filter((option) => optionMatchesSearch(option, search));
}
